module.exports = __webpack_public_path__ + "static/img/Banner.a8709ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Banner.png
// module id = BazY
// module chunks = 0